const { REACT_APP_PUSHER_KEY, REACT_APP_PUSHER_CLUSTER, REACT_APP_API_URL, REACT_APP_MIGRATED_ROUTES } = process.env;

const pusherConfig = {
  PUSHER_KEY: window.PROXY_ENV?.REACT_APP_PUSHER_KEY || REACT_APP_PUSHER_KEY,
  PUSHER_CLUSTER: window.PROXY_ENV?.REACT_APP_PUSHER_CLUSTER || REACT_APP_PUSHER_CLUSTER,
  PUSHER_DISABLED: false
};

const config = {
  API_URL: window.PROXY_ENV?.REACT_APP_API_URL || REACT_APP_API_URL || "http://localhost:3200",
  MIGRATED_ROUTES: window.PROXY_ENV?.MIGRATED_ROUTES || REACT_APP_MIGRATED_ROUTES,
  ...pusherConfig
};

export default config;
